import { ContainerState } from './containerState';
import { ComboBoxState } from './comboBoxState';
import { combineReducers } from 'redux';
import { ButtonBarState } from './buttonBarState';
import { CheckboxListState } from './checkboxListState';
import { SliderState } from './sliderState';
import { RadioListState } from './radioListState';
import { TextFieldState } from './textFieldState';
import { UnknownState } from './unknownState';
import { CrosstabState } from './crosstabState';
import { TableState } from './tableState';
import { VisualizationState } from './visualizationState';
import { ImageState } from './imageState';
import { TextState } from './textState';
import { StackContainerState } from './stackContainerState';
import { WebContentState } from './webContentState';
import { PromptContainerState } from './promptContainerState';
import { JobContentState } from './jobContentState';
import { InfoBarState } from '../infoBar/InfoBarState';
export const birdElementReducer = combineReducers({
    Slider: SliderState.reducer,
    Image: ImageState.reducer,
    Crosstab: CrosstabState.reducer,
    Table: TableState.reducer,
    Text: TextState.reducer,
    RadioList: RadioListState.reducer,
    CheckboxList: CheckboxListState.reducer,
    Container: ContainerState.reducer,
    ComboBox: ComboBoxState.reducer,
    TextField: TextFieldState.reducer,
    DataVisualizations: VisualizationState.reducer,
    ButtonBar: ButtonBarState.reducer,
    StackContainer: StackContainerState.reducer,
    PromptContainer: PromptContainerState.reducer,
    WebContent: WebContentState.reducer,
    JobContent: JobContentState.reducer,
    InfoBar: InfoBarState.reducer,
    Unknown: UnknownState.reducer,
});
